import { useState } from 'react';
import { PageHead } from '../components/ui';
import { ClientOnboardingDeck } from './ClientOnboardingDeck';
import { OnboardingLibrary } from './sales/OnboardingLibrary';

/**
 * Client onboarding — the task library, on a page of its own.
 *
 * THE ONLY PLACE THE LIBRARY IS EDITED. It reached this app inside the Sales
 * module, because an onboarding starts the moment a deal is won and ends when
 * an account manager takes the client over — see migration 054 — and it was a
 * second view on the Sales onboarding tab. It is not a sales artefact though:
 * it is the standing list of what this business does when a client arrives,
 * and the account managers who inherit the client are the ones who maintain
 * it. So it moved here and Sales kept the handover.
 *
 * BEHIND THE `am` CARD for that reason. Its endpoints answer to sales OR am —
 * the onboarding wizard still assigns from this library and that runs in Sales
 * — which is the same shape as the price book: two desks share one thing, and
 * a third card for it would be worse. See the mount in server.ts.
 *
 * The component is imported from pages/sales/ rather than moved. The wizard
 * that assigns from it lives beside it there, and it still reads the same
 * `/sales/onboarding/templates` endpoint; moving the file would be churn in
 * three imports to change nothing a reader can see.
 *
 * WRITING A TASK ON ONE CLIENT is a different thing and is not here. That
 * happens in the onboarding workspace, is copied onto the client with no
 * TemplateId, and never enters this library — an ad-hoc task for one client
 * is not a decision about what every client gets.
 */
export function ClientOnboardingPage() {
  const [presenting, setPresenting] = useState(false);
  return (
    <>
      {/* The lede is deliberately short: the library below opens with its own
          paragraph on how editing behaves, and two ledes stacked is one nobody
          reads. */}
      <PageHead
        title="Client onboarding"
        lede="Every task a new client can be given, and what pulls each one in — the library each onboarding is assembled from."
        actions={
          <button type="button" className="btn btn-secondary" onClick={() => setPresenting(true)}>
            Onboarding presentation
          </button>
        }
      />
      {/* The four slides shown to a new client at kickoff. */}
      {presenting && <ClientOnboardingDeck onClose={() => setPresenting(false)} />}
      <OnboardingLibrary />
    </>
  );
}
